import { usePlanIsSecret as useIsSecret } from "@/components/features/items/edit/plan/_shared/ui/components/plan-attributes/is-secret/hooks";

import { useProductDayTripPlanFormModelContext } from "../../../../context";

export const useDayTripPlanIsSecret = () => {
	const { viewModel, onSetViewModel } = useProductDayTripPlanFormModelContext();
	const { isPrivate: isSecret, hotelID } = viewModel;

	return {
		...useIsSecret({
			isSecret,
			onSetViewModel,
		}),
		hotelID,
	};
};
